import React from 'react';
import Typography from 'new/elements/Typography';
import { TextField } from 'new/elements/TextField';

import classes from './CodeEditorMetaFields.module.scss';

export interface CodeEditorMetaFieldsProps {
  nameInput: string;
  descriptionInput: string;
  isJsonValid: boolean;
  helperText?: string;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDescriptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CodeEditorMetaFields = (props: CodeEditorMetaFieldsProps) => {
  const {
    nameInput,
    descriptionInput,
    isJsonValid,
    helperText,
    onNameChange,
    onDescriptionChange,
  } = props;

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <div className={classes.cell}>
          <TextField
            fullWidth
            label="Name"
            htmlFor="code-editor-mode-name"
            value={nameInput}
            onChange={onNameChange}
            disabled={!isJsonValid}
            inputProps={{
              'data-testid': 'code-editor-mode-name',
              id: 'code-editor-mode-name',
            }}
          />
        </div>
        <div className={classes.cell}>
          <TextField
            fullWidth
            label="Description"
            htmlFor="code-editor-mode-description"
            value={descriptionInput}
            onChange={onDescriptionChange}
            disabled={!isJsonValid}
            multiline
            inputProps={{
              'data-testid': 'code-editor-mode-description',
              id: 'code-editor-mode-description',
            }}
          />
        </div>
      </div>
      {helperText ? (
        <Typography variant="bodySmall" className={classes.helper} component="p">
          {helperText}
        </Typography>
      ) : null}
    </div>
  );
};
